export default "__VITE_ASSET__f2ZVM6nm__"